import { useMemo } from "react";
import PropTypes from "prop-types";

import MegaMenuItemPresenter from "presenters/MegaMenuItemPresenter";
import { useAlgolia } from "hooks";

import MenuItem from "./components/MenuItem";
import { Root } from "./styles";

const Navigation = ({ menuItems }) => {
  const { clearAllFiltersByPath } = useAlgolia();

  const mainMenuLinks = useMemo(
    () => menuItems?.map((item) => MegaMenuItemPresenter.linkTo(item.menu)).filter(Boolean) || [],
    [menuItems],
  );

  return (
    <Root>
      {menuItems &&
        menuItems.map((item) => (
          <MenuItem
            key={item.name}
            menuItem={item.menu}
            mainMenuLinks={mainMenuLinks}
            onClick={() => clearAllFiltersByPath({ path: MegaMenuItemPresenter.linkTo(item.menu) })}
          />
        ))}
    </Root>
  );
};

Navigation.propTypes = {
  menuItems: PropTypes.arrayOf(MegaMenuItemPresenter.shape()),
};

export default Navigation;
